module.exports = __webpack_public_path__ + "img/talents.88221021.png";